export function getPlatformInitData() {
  // Проверяем MAX Bridge
  // В MAX объект висит прямо на window.WebApp [citation:1][citation:9]
  if (window.WebApp?.initData) {
    return { initData: window.WebApp.initData, platform: "max" };
  }

  // Проверяем Telegram (для @twa-dev/sdk или нативного скрипта)
  // В Telegram initData может быть в window.Telegram.WebApp или в window.location.hash [citation:5][citation:17]
  if (window.Telegram?.WebApp?.initData) {
    return { initData: window.Telegram.WebApp.initData, platform: "telegram" };
  }

  // Фолбэк для Telegram, если initData пустой, но есть хэш
  const hash = window.location.hash.slice(1);
  if (hash) {
    const params = new URLSearchParams(hash);
    const tgData = params.get('tgWebAppData');
    if (tgData) {
      return { initData: tgData, platform: "telegram" };
    }
  }

  // Если ничего не найдено (открыто в обычном браузере)
  return { initData: null, platform: "web" };
}